import React from "react";
import ArrowButton from "../ArrowButton";
import { ReactComponent as HomePagePopupIcon } from "../../assets/images/svg/homePagePopupIcon.svg";

function HealthCheckPopup({ onClick }) {
  return (
    <div className="home_popup_container">
      <HomePagePopupIcon />
      <p className="home_popup_info_text">
        The portfolio may have some data discrepancy, please do not send report
        to client. We are working on fixing the same. The client login has been
        temporarily disabled.
      </p>
      <div className="home_page_popup_arrow_btn">
        <ArrowButton
          onClick={onClick}
          type={"next"}
          label={"Got it! Continue"}
          styleProp={{
            borderRadius: "15px",
          }}
        />
      </div>
    </div>
  );
}

export default HealthCheckPopup;
